import * as React from 'react';
import { connect } from 'react-redux';
import { Icon, Title, Text, Box } from 'sg-styleguide';

import SelectButton from '../select-button/';
import PromoSystem from '../promo-system';
import PluginWrapper from '../../containers/plugin-wrapper';

import {
	FlexWithPadding,
	SelectBoxwithBorder
} from '../helpers';

class BuilderPlugin extends React.Component {
	constructor(props) {
		super(props);

		if (  this.props.is_recommended ) {
			this.props.addPlugin( this.props.id )
		}
	}

	render () {
		return (
			<Box sm={this.props.size}>
				<SelectBoxwithBorder
					label={window.wizardData.strings.recommended}
					type="active"
				>
					<FlexWithPadding
						align="center"
						margin="none"
						padding={['medium', 'none', 'medium', 'none']}
						direction="column"
					>
						<img src={this.props.logo_url} width="50" height="50"/>

						<Title
							level="3"
							density="cozy"
						>
							{this.props.name}
						</Title>
						<SelectButton
							onClick={e => this.props.onClick(this.props.id)}
							selected={this.props.selected}
							text={window.wizardData.strings.select}
							textSelected={window.wizardData.strings.selected}
						/>
					</FlexWithPadding>
					<Box
						className="ua-border-top ua-padding-medium"
					>
						<Text
							color="dark"
							className="ua-margin-bottom-medium"
							align="left"
						>
							{this.props.localeDescription.description}
						</Text>

						<PromoSystem
							price={this.props.getPrice()}
							partner={window.wizardData.strings.plugin_by + " " + this.props.author}
							align="left"
						/>
					</Box>
				</SelectBoxwithBorder>
			</Box>
		);
	}

};

export default PluginWrapper(BuilderPlugin);
